"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CEKConst = void 0;
var uplc_1 = require("@harmoniclabs/uplc");
var CEKConst = /** @class */ (function () {
    function CEKConst(type, value) {
        this.type = type;
        this.value = value;
    }
    CEKConst.fromUplc = function (uplc) {
        return new CEKConst(uplc.type, uplc.value);
    };
    CEKConst.prototype.clone = function () {
        return new CEKConst(this.type, this.value);
    };
    CEKConst.int = function (int) {
        return CEKConst.fromUplc(uplc_1.UPLCConst.int(int));
    };
    CEKConst.byteString = function (bs) {
        return CEKConst.fromUplc(uplc_1.UPLCConst.byteString(bs));
    };
    CEKConst.str = function (str) {
        return CEKConst.fromUplc(uplc_1.UPLCConst.str(str));
    };
    Object.defineProperty(CEKConst, "unit", {
        get: function () {
            return CEKConst.fromUplc(uplc_1.UPLCConst.unit);
        },
        enumerable: false,
        configurable: true
    });
    CEKConst.bool = function (bool) {
        return CEKConst.fromUplc(uplc_1.UPLCConst.bool(bool));
    };
    CEKConst.listOf = function (typeArg) {
        return function (values) {
            return CEKConst.fromUplc(uplc_1.UPLCConst.listOf(typeArg)(values));
        };
    };
    CEKConst.pairOf = function (typeArgFirst, typeArgSecond) {
        return function (first, second) {
            return CEKConst.fromUplc(uplc_1.UPLCConst.pairOf(typeArgFirst, typeArgSecond)(first, second));
        };
    };
    CEKConst.data = function (data) {
        return CEKConst.fromUplc(uplc_1.UPLCConst.data(data));
    };
    CEKConst.bls12_381_G1_element = function (g1) {
        return CEKConst.fromUplc(uplc_1.UPLCConst.bls12_381_G1_element(g1));
    };
    CEKConst.bls12_381_G2_element = function (g2) {
        return CEKConst.fromUplc(uplc_1.UPLCConst.bls12_381_G2_element(g2));
    };
    CEKConst.bls12_381_MlResult = function (mlResult) {
        return CEKConst.fromUplc(uplc_1.UPLCConst.bls12_381_MlResult(mlResult));
    };
    return CEKConst;
}());
exports.CEKConst = CEKConst;
